import React from 'react';
import { Search, Menu, Home } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export function Header({ isDark, toggleTheme, completionPercent, onSearchOpen, onMenuToggle, onHome }) {
  return (
    <header
      data-testid="app-header"
      className="fixed top-0 left-0 right-0 z-50 h-16 border-b border-zinc-200 dark:border-zinc-800 backdrop-blur-xl bg-white/80 dark:bg-zinc-950/80"
    >
      <div className="h-full flex items-center px-4 gap-3">
        <Button
          data-testid="mobile-menu-toggle"
          variant="ghost"
          size="icon"
          className="lg:hidden shrink-0"
          onClick={onMenuToggle}
        >
          <Menu className="h-5 w-5" />
        </Button>

        <div className="flex items-center gap-3 shrink-0">
          <img src="/steadfast-logo.png" alt="Steadfast" className="h-9 w-auto" data-testid="steadfast-logo" />
          <div className="w-px h-8 bg-zinc-200 dark:bg-zinc-700 hidden sm:block" />
          <img src="/servicenow-logo.png" alt="ServiceNow" className="h-6 w-auto hidden sm:block" data-testid="servicenow-logo" />
        </div>

        {/* Home button */}
        <TooltipProvider delayDuration={300}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                data-testid="home-btn"
                variant="ghost"
                size="icon"
                onClick={onHome}
                className="shrink-0 ml-1"
              >
                <Home className="h-5 w-5" />
              </Button>
            </TooltipTrigger>
            <TooltipContent><p>Back to Home</p></TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <div className="flex-1 min-w-0" />

        <div className="hidden md:flex items-center gap-2 min-w-[200px] max-w-[300px]">
          <span className="text-xs font-semibold text-zinc-500 dark:text-zinc-400 whitespace-nowrap">
            {completionPercent}%
          </span>
          <Progress data-testid="progress-bar" value={completionPercent} className="h-2 flex-1 bg-zinc-100 dark:bg-zinc-800" />
        </div>

        <Button
          data-testid="search-trigger"
          variant="outline"
          size="sm"
          className="hidden sm:flex items-center gap-2 text-zinc-500 dark:text-zinc-400 border-zinc-200 dark:border-zinc-700 h-9 px-3"
          onClick={onSearchOpen}
        >
          <Search className="h-4 w-4" />
          <span className="text-xs">Search...</span>
          <kbd className="ml-2 text-[10px] bg-zinc-100 dark:bg-zinc-800 px-1.5 py-0.5 rounded font-mono">Ctrl+K</kbd>
        </Button>

        <Button data-testid="search-trigger-mobile" variant="ghost" size="icon" className="sm:hidden" onClick={onSearchOpen}>
          <Search className="h-5 w-5" />
        </Button>


      </div>
    </header>
  );
}
